import script from "./lamplist.vue?vue&type=script&setup=true&lang=js"
export * from "./lamplist.vue?vue&type=script&setup=true&lang=js"

import "./lamplist.vue?vue&type=style&index=0&id=1cf4305a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cf4305a"]])

export default __exports__